import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// stext-*/sborder-*/sring-* (packages/primitive/src/styles/tokens/utility.css) are the
// short-form aliases for the text/border/ring semantic color tokens - they exist precisely
// to be swapped in for the long text-text-*/border-border-*/ring-ring-* form. twMerge doesn't
// know about them by default, so without this it can't tell that e.g. `stext-contrast-default`
// is meant to override `text-text-base-default`: both survive in the class string, and which
// one wins then depends on generated CSS order rather than call-site intent. Registering them
// in the matching class group lets twMerge dedupe them exactly like the native long form.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'text-color': [{ stext: [() => true] }],
      'border-color': [{ sborder: [() => true] }],
      'ring-color': [{ sring: [() => true] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
